import React from "react";

interface LeftRightLayoutIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const LeftRightLayoutIcon: React.FC<LeftRightLayoutIconProps> = ({ size = 22, color = '#1E1F22', className, onClick }) => (
  <svg width="353" height="36" viewBox="0 0 353 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="353" height="36" rx="3" fill="white" />
    <rect x="15" y="8" width="20" height="20" fill="#2D6FFF" fillOpacity="0.5" />
    <g clip-path="url(#clip0_188_10700)">
      <rect x="215" y="13" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
      <rect x="280" y="13" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
    </g>
    <defs>
      <clipPath id="clip0_188_10700">
        <rect width="123" height="5" fill="white" transform="translate(215 15.5)" />
      </clipPath>
    </defs>
  </svg>


);

export default LeftRightLayoutIcon;
